// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from 'firebase/app';

// Add the Firebase services that you want to use
// import 'firebase/auth;
// import 'firebase/firestore;
import 'firebase/analytics';
import 'firebase/functions';

firebase.initializeApp({
  apiKey: "AIzaSyDisCMJvaXMwJA2jjTQNyug3Bp9p4bvedo",
  authDomain: "buysmth.firebaseapp.com",
  databaseURL: "https://buysmth.firebaseio.com",
  projectId: "buysmth",
  storageBucket: "buysmth.appspot.com",
  messagingSenderId: "665648212404",
  appId: "1:665648212404:web:c2415dc99ce255161caae1",
  measurementId: "G-J8CF8ZJ4QB"
});
firebase.analytics();

export { firebase };